// SideBySideLayout.js
import React, { Component } from "react";
import { isMobileApp } from "../../../actions/Util";

class SideBySideLayout extends Component {
  render() {
    const left = Object.prototype.hasOwnProperty.call(this.props, "left")
      ? this.props.left
      : null;

    const right = Object.prototype.hasOwnProperty.call(this.props, "right")
      ? this.props.right
      : null;

    const showFullScreen = Object.prototype.hasOwnProperty.call(
      this.props,
      "showFullScreen"
    )
      ? this.props.showFullScreen
      : false;

    // Get custom widths or use defaults
    const leftWidth = Object.prototype.hasOwnProperty.call(this.props, "leftWidth")
      ? this.props.leftWidth
      : "25%";

    const rightWidth = Object.prototype.hasOwnProperty.call(this.props, "rightWidth")
      ? this.props.rightWidth
      : "75%";

    const outerContainerStyle = {
      display: "flex",
      width: "100%",
      height: "100vh",
      overflow: "hidden",
      background: "linear-gradient(to bottom right, #f3f4f6, #e5e7eb)",
      padding: isMobileApp() ? "0px" : "10px"
    };

    const innerContainerStyle = {
      display: "flex",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      borderRadius: isMobileApp() ? "0px" : "16px"
    };

    const leftPanelStyle = {
      width: leftWidth,
      borderRight: "2px solid #e5e7eb",
      backgroundColor: "#ffffff"
    };

    const rightPanelStyle = {
      width: showFullScreen ? "100%" : rightWidth,
      backgroundColor: "#ffffff"
    };

    const mobilePanelStyle = {
      width: "100%",
      backgroundColor: "#ffffff"
    };

    return (
      <div style={outerContainerStyle}>
        {isMobileApp() && (
          <div style={innerContainerStyle}>
            <div style={mobilePanelStyle}>
              {right}
            </div>
          </div>
        )}

        {!isMobileApp() && (
          <div style={innerContainerStyle}>
            {!showFullScreen && (
              <div style={leftPanelStyle}>
                {left}
              </div>
            )}

            <div style={rightPanelStyle}>
              {right}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SideBySideLayout;